import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = (params) => ['getWorkers', ...Object.values(params)];

export const getWorkers = async (params) => {
  return await request.get(
    '/Request/workers',
    params,
    'При получении списка мастеров произошла ошибка'
  );
};

const useWorkersQuery = (params, options) =>
  useQuery(key(params), () => getWorkers(params), options);

export default useWorkersQuery;
